import RMSCkycContainer from "./RMSCkycContainer";
import RMSCkycStore from "./RMSCkycStore";

export default RMSCkycStore(RMSCkycContainer);
